import React from 'react';
import { MediaList } from 'components/media-list/MediaList';
import { MediaListItem } from 'components/media-list/MediaListItem';

export const MediaListSlice = ({ title, archive, aspect, items, isSlice }) => {
  return (
    <MediaList title={title} aspect={aspect} archive={archive} isSlice={isSlice}>
      {items?.map((item, index) => (
        <MediaListItem
          key={index}
          title={item.title}
          subline={item.subline}
          image={item.image}
          aspect={aspect}
        />
      ))}
    </MediaList>
  );
};

export default MediaListSlice;
